/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { batchActions } from 'redux-batched-actions';
// actions
import { applyStoryURL, setStoryProperty, setCurrentUniqueProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import StoryProperties from 'pages/dashboard/embeds/management/customize/cardproperties/storyproperties/storyproperties';



/* ========== ~~~~~~~~~~ EMBED STORY PROPERTIES : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    return {
        location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
        partnerLogo: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.partnerLogo,
        contentId: embedsState.embedManagementState.contentStatus['selectedContent'],
        url: !contentStatus.noLiveContents ? contentStatus.contents[contentStatus.selectedContent]['story'].url : null,
        isURLValid: !contentStatus.noLiveContents ? contentStatus.contents[contentStatus.selectedContent]['story'].isURLValid : null,
        storyURLDataReceived: !contentStatus.noLiveContents ? contentStatus.contents[contentStatus.selectedContent].storyURLDataReceived : null,
    }};

const mapDispatchToProps = (dispatch) => ({
    applyStoryURL: (contentId, url) => dispatch(applyStoryURL(contentId, url)),
    setStoryProperty: (contentId, property, value) => dispatch(setStoryProperty(contentId, property, value)),
    setCurrentUniqueProperty: (contentId, property, value) => dispatch(setCurrentUniqueProperty(contentId, property, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps, 
    mapDispatchToProps
)(StoryProperties);
